import { Component, OnInit, inject, signal, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgIcon } from '@ng-icons/core';
import { SuggestionService } from '@core/services/suggestions/suggestion.service';
import { ToastService } from '@core/services/toast/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-suggestion-widget',
  standalone: true,
  imports: [CommonModule, FormsModule, NgIcon],
  templateUrl: './suggestion-widget.html',
  styleUrl: './suggestion-widget.css',
})
export class SuggestionWidgetComponent implements OnInit {
  private suggestionService = inject(SuggestionService);
  private toastService = inject(ToastService);
  private destroyRef = inject(DestroyRef);

  isOpen = signal<boolean>(false);
  loading = signal<boolean>(false);
  submitting = signal<boolean>(false);
  suggestions = signal<any[]>([]);
  newSuggestion = signal<string>('');

  ngOnInit() {
    this.loadSuggestions();
  }

  toggleChat() {
    this.isOpen.set(!this.isOpen());
    if (this.isOpen()) {
      this.loadSuggestions();
    }
  }

  loadSuggestions() {
    this.loading.set(true);
    this.suggestionService.getSuggestions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          if (res?.success && res?.data) {
            this.suggestions.set(res.data);
          }
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
        }
      });
  }

  submitSuggestion() {
    const text = this.newSuggestion().trim();
    if (!text) return;

    this.submitting.set(true);
    this.suggestionService.createSuggestion(text)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.newSuggestion.set('');
          this.loadSuggestions();
          this.toastService.showToast('Votre suggestion a été envoyée !', false);
          this.submitting.set(false);
        },
        error: () => {
          this.toastService.showToast("Erreur lors de l'envoi de la suggestion", true);
          this.submitting.set(false);
        }
      });
  }

  getStatusClass(status: string): string {
    switch(status) {
      case 'UNDER_REVIEW': return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border-amber-200 dark:border-amber-800/50';
      case 'APPROVED': return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800/50';
      case 'REJECTED': return 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400 border-rose-200 dark:border-rose-800/50';
      default: return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700';
    }
  }
}
